"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Queue = /** @class */ (function () {
    function Queue(index) {
        this.index = index;
        this.queue = new Set(index.all);
    }
    Queue.prototype.mark = function (property) {
        var _this = this;
        this.index.withProperty(property).forEach(function (i) { return _this.queue.add(i); });
    };
    Queue.prototype.shift = function () {
        var item = this.queue.values().next().value;
        if (item) {
            this.queue.delete(item);
        }
        return item;
    };
    return Queue;
}());
exports.default = Queue;
